import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { useUserProfile } from '../../helper/UserProfile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { faBookMedical } from '@fortawesome/free-solid-svg-icons';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';

function MobileNavigation() {
  const location = useLocation();
  const { profile } = useUserProfile();
  const [member, setMember] = useState("");

  const isRevalidationActive = location.pathname.startsWith("/dashboard/revalidation");

  useEffect(() => {
    if (profile && profile.revalidation_membership !== undefined) {
        setMember(profile.revalidation_membership);
    }
}, [profile]);

  return (
    <div className="mobile-nav">
        <Link to={member === false ? "/dashboard/signup" : "/dashboard/revalidation"}>
        <div className={isRevalidationActive || location.pathname === "/dashboard/signup" ? "active mob-nav-list" : "mob-nav-list"}>
        {member === false && <FontAwesomeIcon icon={faLock} style={{paddingBottom: "8px"}}/>}
        {member === true && <FontAwesomeIcon icon={faClipboardList} style={{paddingBottom: "8px"}}/>}REVALIDATION</div></Link>

        <div className="mob-nav-list"><FontAwesomeIcon icon={faBookMedical} style={{paddingBottom: "8px"}}/>COURSES</div>

        <Link to="/dashboard/support"><div className={location.pathname === "/dashboard/support" ? "active mob-nav-list" : "mob-nav-list"}><FontAwesomeIcon icon={faHeadset} style={{paddingBottom: "8px"}}/>SUPPORT</div></Link>
        
        <Link to="/dashboard/profile">
        <div className={location.pathname === "/dashboard/profile" ? "active mob-nav-list" : "mob-nav-list"}><FontAwesomeIcon icon={faCircleUser} style={{paddingBottom: "8px"}}/>PROFILE</div></Link>

    </div>
  )
}

export default MobileNavigation